<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Change Password Confirmation
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body" style="position: relative">
  <form
    action=""
    [formGroup]="changePassForm"
    autocomplete="off"
    spellcheck="false"
  >
    <mat-form-field appearance="outline">
      <mat-label>Current Password</mat-label>
      <input
        matInput
        placeholder="Current Password"
        [type]="!fieldTextType1 ? 'text' : 'password'"
        formControlName="currentPass"
      />
      <mat-icon
        *ngIf="changePassForm.get('currentPass').value != (null || '')"
        (click)="togglePassswordIcon(1)"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType1,
          'bi-eye-slash-fill': !fieldTextType1
        }"
      ></mat-icon>
      <mat-error
        *ngIf="
          changePassForm.get('currentPass').touched &&
          changePassForm.get('currentPass').errors?.required
        "
        >Current Password Required*</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input
        matInput
        placeholder="New Password"
        [type]="!fieldTextType2 ? 'text' : 'password'"
        formControlName="newPass"
      />
      <mat-icon
        *ngIf="changePassForm.get('newPass').value != (null || '')"
        (click)="togglePassswordIcon(2)"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType2,
          'bi-eye-slash-fill': !fieldTextType2
        }"
      ></mat-icon>
      <mat-error
        *ngIf="
          changePassForm.get('newPass').touched &&
          changePassForm.get('newPass').errors?.required
        "
        >New Password Required*</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Confirm New Password</mat-label>
      <input
        matInput
        placeholder="Confirm New Passoword"
        [type]="!fieldTextType3 ? 'text' : 'password'"
        formControlName="confirmNewPass"
      />
      <mat-icon
        *ngIf="changePassForm.get('confirmNewPass').value != (null || '')"
        (click)="togglePassswordIcon(3)"
        matSuffix
        class="bi classPassIcon"
        [ngClass]="{
          'bi-eye-fill': fieldTextType3,
          'bi-eye-slash-fill': !fieldTextType3
        }"
      ></mat-icon>
      <mat-error
        *ngIf="
          changePassForm.get('confirmNewPass').touched &&
          changePassForm.get('confirmNewPass').errors?.required
        "
        >Confirm Password Required*</mat-error
      >
    </mat-form-field>
  </form>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    type="ball-spin"
    [fullScreen]="false"
    name="changePassword"
    ><p class="pleaseWait" style="margin-top: 3rem!important;">Please wait ...</p></ngx-spinner
  >
  <div class="text-center">
    <p class="text-danger">{{ errorMsg }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">
    Submit
  </button>
</div>
